import _ from "lodash";
import { colors } from "Constants";
import React from "react";
import {
  ROLE_ADMIN,
  ROLE_SUPERVISOR,
  ROLE_STUDENT,
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_STATUS_PENDING_FOR_APPROVAL,
  PROJECT_STATUS_NOT_STARTED,
  PROJECT_STATUS_DOING_GREAT,
  PROJECT_STATUS_NOT_QUITE,
  PROJECT_STATUS_IN_PROGRESS,
  PROJECT_STATUS_REVIEW_REQUESTED,
  PROJECT_STATUS_COMPLETED,
  PROJECT_REPORT_STATUS_PENDING,
  PROJECT_REPORT_STATUS_SUBMITTED,
  PROJECT_STATUS_REJECTED,
  PROJECT_REPORT_STATUS_APPROVED,
  PROJECT_STATUS_VERY_GOOD,
  PROJECT_STATUS_AVERAGE,
  PROJECT_STATUS_GOOD,
  PROJECT_STATUS_POOR,
  PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL,
  PROJECT_STATUS_APPROVED,
  PROJECT_STATUS_DRAFT,
  PROJECT_REPORT_STATUS_NOT_STARTED,
  PROJECT_REPORT_STATUS_NON_SUBMISSION,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_REPORT_STATUS_IN_PROGRESS,
  PORTFOLIO_EXPERIENCE,
  PORTFOLIO_PROJECT,
  LAST_MODIFIED_TODAY,
  LAST_MODIFIED_LAST_SEVEN_DAYS,
  LAST_MODIFIED_LAST_MONTH,
  LAST_MODIFIED_ANYTIME,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECTS_ENABLE_REJECTION_STATUS_PERM,
  PROJECT_REPORT_STATUS_REJECTED,
  MANAGE_SETUP_AND_ALL_STUDENT_PROJECTS_PERMISSION,
  PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO,
} from "Projects/Constants/stringConstants";
import ACLStorage from "lib/aclService";
import {
  CAN_VIEW_AND_MANAGE_ALL_PROJECT_GROUP_TYPES,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
} from "Constants/permissionConstants";
import { getProjectGroupContexts } from "Platform/modules/PlatformUtils";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import ACLStore from "lib/aclStore";
import {
  BadgeTickFilled,
  InProgressThumbsupOutlined,
} from "@toddle-edu/ds-icons";

export const ROLES_MAP = {
  coordinator: {
    id: "coordinator",
    value: ROLE_ADMIN,
  },
  supervisor: {
    id: "supervisor",
    value: ROLE_SUPERVISOR,
  },
  student: {
    id: "student",
    value: ROLE_STUDENT,
  },
};

export const ALL_PROJECT_GROUP_TYPES = [
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
];

export const BIN_PROJECT_GROUP_TYPES = [
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
];

export const checkIsProjectCoordinator = ({
  projectGroupCategoryId,
  curriculumProgramId,
}) => {
  const projectGroupContexts = getProjectGroupContexts({
    projectGroupCategoryId,
    curriculumProgramId,
  });

  return (
    ACLStorage.getPermissionValueByContext(
      MANAGE_SETUP_AND_ALL_STUDENT_PROJECTS_PERMISSION,
      projectGroupContexts
    ) ||
    (ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)
      ? ACLStorage.getModuleSettingsValueByContext(
          CAN_VIEW_AND_MANAGE_ALL_PROJECT_GROUP_TYPES,
          projectGroupContexts
        )
      : getIsAdminByRole())
  );
};

export const getRoleValue = ({
  user_type,
  projectGroupCategoryId,
  curriculumProgramId,
}) => {
  const isAdmin = checkIsProjectCoordinator({
    projectGroupCategoryId,
    curriculumProgramId,
  });

  if (isAdmin) {
    return ROLES_MAP.coordinator.value;
  } else if (user_type == "staff") {
    return ROLES_MAP.supervisor.value;
  } else {
    return ROLES_MAP.student.value;
  }
};

export const getIsCoreOrSubjectGroupType = ({ projectGroupType }) => {
  return _.includes(ALL_PROJECT_GROUP_TYPES, projectGroupType);
};

export const PORTFOLIO_PROJECT_EXPERIENCE_TYPES = {
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: [
    {
      id: PORTFOLIO_EXPERIENCE,
      label: "project:sl_experience_plural",
    },
    {
      id: PORTFOLIO_PROJECT,
      label: "project:sl_project_plural",
    },
  ],
  [PROJECT_GROUP_TYPE_DP_CAS]: [
    {
      id: PORTFOLIO_EXPERIENCE,
      label: "project:cas_experience_plural",
    },
    {
      id: PORTFOLIO_PROJECT,
      label: "project:cas_projects",
    },
  ],
};

export const LAST_MODIFIED_OPTIONS = [
  {
    id: LAST_MODIFIED_TODAY,
    label: "common:today",
  },
  {
    id: LAST_MODIFIED_LAST_SEVEN_DAYS,
    label: "project:last_seven_days",
  },
  {
    id: LAST_MODIFIED_LAST_MONTH,
    label: "project:last_month",
  },
  {
    id: LAST_MODIFIED_ANYTIME,
    label: "project:anytime",
  },
];

export const PROJECT_STATUS = {
  [PROJECT_STATUS_DRAFT]: {
    id: PROJECT_STATUS_DRAFT,
    label: "common:draft",
    color: colors.yellow500,
    categoryTypes: [PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO],
    iconType: "fileOutlinedIcon",
    iconVariant: "subtle",
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_COMPLETED,
        PROJECT_STATUS_REJECTED,
        PROJECT_STATUS_APPROVED,
        PROJECT_STATUS_DRAFT,
      ],
    },
  },
  [PROJECT_STATUS_NOT_STARTED]: {
    id: PROJECT_STATUS_NOT_STARTED,
    label: "project:to_be_determined",
    color: colors.yellow500,
    projects: [
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_DP_G4_PROJECT,
      PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_DOING_GREAT,
        PROJECT_STATUS_NOT_QUITE,
        PROJECT_STATUS_POOR,
        PROJECT_STATUS_AVERAGE,
        PROJECT_STATUS_GOOD,
        PROJECT_STATUS_VERY_GOOD,
        PROJECT_STATUS_IN_PROGRESS,
        PROJECT_STATUS_REVIEW_REQUESTED,
        PROJECT_STATUS_COMPLETED,
        PROJECT_STATUS_REJECTED,
        PROJECT_STATUS_APPROVED,
      ],
    },
  },
  [PROJECT_STATUS_DOING_GREAT]: {
    id: PROJECT_STATUS_DOING_GREAT,
    label: "project:doing_great",
    color: colors.grass,
    projects: [PROJECT_GROUP_TYPE_COMMUNITY, PROJECT_GROUP_TYPE_PERSONAL],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_DOING_GREAT,
        PROJECT_STATUS_NOT_QUITE,
      ],
    },
  },
  [PROJECT_STATUS_NOT_QUITE]: {
    id: PROJECT_STATUS_NOT_QUITE,
    label: "project:not_quite",
    color: colors.salmon60,
    projects: [
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_DP_G4_PROJECT,
      PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
      PROJECT_GROUP_TYPE_PERSONAL,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_DOING_GREAT,
        PROJECT_STATUS_NOT_QUITE,
      ],
    },
  },
  [PROJECT_STATUS_APPROVED]: {
    id: PROJECT_STATUS_APPROVED,
    label: "common:approved",
    color: colors.success42,
    categoryTypes: [PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO],
    iconType: "inProgressThumbsUpIcon",
    iconVariant: "success",
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_PENDING_FOR_APPROVAL,
        PROJECT_STATUS_COMPLETED,
        PROJECT_STATUS_REJECTED,
        PROJECT_STATUS_APPROVED,
        PROJECT_STATUS_DRAFT,
      ],
    },
  },
  [PROJECT_STATUS_COMPLETED]: {
    id: PROJECT_STATUS_COMPLETED,
    label: "common:completed",
    color: colors.success42,
    iconType: "badgeFilledIcon",
    iconVariant: "success",
    categoryTypes: [PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_PENDING_FOR_APPROVAL,
        PROJECT_STATUS_IN_PROGRESS,
        PROJECT_STATUS_REVIEW_REQUESTED,
        PROJECT_STATUS_COMPLETED,
        PROJECT_STATUS_REJECTED,
        PROJECT_STATUS_APPROVED,
        PROJECT_STATUS_DRAFT,
      ],
    },
  },
  [PROJECT_STATUS_REJECTED]: {
    id: PROJECT_STATUS_REJECTED,
    label: "common:rejected",
    color: colors.borderCritical,
    categoryTypes: [PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO],
    iconType: "closeCircleFilledIcon",
    iconVariant: "critical",
    perm: PROJECTS_ENABLE_REJECTION_STATUS_PERM,
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_PENDING_FOR_APPROVAL,
        PROJECT_STATUS_COMPLETED,
        PROJECT_STATUS_REJECTED,
        PROJECT_STATUS_APPROVED,
        PROJECT_STATUS_DRAFT,
      ],
    },
  },
  [PROJECT_STATUS_POOR]: {
    id: PROJECT_STATUS_POOR,
    label: "project:poor_progress",
    color: colors.red52,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_DP_G4_PROJECT,
      PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_POOR,
        PROJECT_STATUS_AVERAGE,
        PROJECT_STATUS_GOOD,
        PROJECT_STATUS_VERY_GOOD,
      ],
    },
  },
  [PROJECT_STATUS_AVERAGE]: {
    id: PROJECT_STATUS_AVERAGE,
    label: "project:average_progress",
    color: colors.yellow400,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_POOR,
        PROJECT_STATUS_AVERAGE,
        PROJECT_STATUS_GOOD,
        PROJECT_STATUS_VERY_GOOD,
      ],
    },
  },
  [PROJECT_STATUS_GOOD]: {
    id: PROJECT_STATUS_GOOD,
    label: "project:good_progress",
    color: colors.blue400,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_POOR,
        PROJECT_STATUS_AVERAGE,
        PROJECT_STATUS_GOOD,
        PROJECT_STATUS_VERY_GOOD,
      ],
    },
  },
  [PROJECT_STATUS_VERY_GOOD]: {
    id: PROJECT_STATUS_VERY_GOOD,
    label: "project:exceeding_expectations",
    color: colors.blue400,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_STATUS_NOT_STARTED,
        PROJECT_STATUS_POOR,
        PROJECT_STATUS_AVERAGE,
        PROJECT_STATUS_GOOD,
        PROJECT_STATUS_VERY_GOOD,
      ],
    },
  },
};

export const PROJECT_REPORT_STATUS = {
  [PROJECT_REPORT_STATUS_PENDING]: {
    id: PROJECT_REPORT_STATUS_PENDING,
    label: "project:pending",
    color: colors.yellow500,
    projects: [
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_PENDING,
        PROJECT_REPORT_STATUS_SUBMITTED,
        PROJECT_REPORT_STATUS_APPROVED,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_SUBMITTED]: {
    id: PROJECT_REPORT_STATUS_SUBMITTED,
    label: "common:completed",
    color: colors.teal600,
    projects: [
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_PENDING,
        PROJECT_REPORT_STATUS_SUBMITTED,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL]: {
    id: PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL,
    label: "project:pending_for_approval",
    color: colors.yellow500,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL,
        PROJECT_REPORT_STATUS_APPROVED,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_APPROVED]: {
    id: PROJECT_REPORT_STATUS_APPROVED,
    label: "project:approved",
    color: colors.teal500,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL,
        PROJECT_REPORT_STATUS_APPROVED,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_IN_PROGRESS]: {
    id: PROJECT_REPORT_STATUS_IN_PROGRESS,
    label: "project:in_progress",
    color: colors.teal500,
    projects: [],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [],
    },
  },
  [PROJECT_REPORT_STATUS_NOT_STARTED]: {
    id: PROJECT_REPORT_STATUS_NOT_STARTED,
    label: "common:not_started_sentence_case",
    color: colors.yellow500,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
      PROJECT_GROUP_TYPE_DP_CAS,
      PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
      PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_NOT_STARTED,
        PROJECT_REPORT_STATUS_APPROVED,
        PROJECT_REPORT_STATUS_SUBMITTED,
        PROJECT_REPORT_STATUS_NON_SUBMISSION,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_NON_SUBMISSION]: {
    id: PROJECT_REPORT_STATUS_NON_SUBMISSION,
    label: "project:non_submission",
    color: colors.borderCritical,
    projects: [
      PROJECT_GROUP_TYPE_DP_EE,
      PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
      PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
      PROJECT_GROUP_TYPE_COMMUNITY,
      PROJECT_GROUP_TYPE_PERSONAL,
      PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
      PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
    ],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_NON_SUBMISSION,
        PROJECT_REPORT_STATUS_APPROVED,
        PROJECT_REPORT_STATUS_NOT_STARTED,
        PROJECT_REPORT_STATUS_SUBMITTED,
      ],
    },
  },
  [PROJECT_REPORT_STATUS_REJECTED]: {
    id: PROJECT_REPORT_STATUS_REJECTED,
    label: "project:rejected",
    color: colors.borderCritical,
    projects: [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON],
    disableStatus: {
      [ROLE_ADMIN]: [],
      [ROLE_SUPERVISOR]: [],
      [ROLE_STUDENT]: [
        PROJECT_REPORT_STATUS_NOT_STARTED,
        PROJECT_REPORT_STATUS_APPROVED,
        PROJECT_REPORT_STATUS_SUBMITTED,
      ],
    },
  },
};

export const PROJECT_REPORT_STATUS_FILTER_OPTIONS = {
  [PROJECT_REPORT_STATUS_NOT_STARTED]: {
    label: "project:not_started",
    value: PROJECT_REPORT_STATUS_NOT_STARTED,
    iconType: "dashedCircleMinusIcon",
    iconTypeV2: "DashedCircleMinusOutlined",
    iconVariant: "subtle",
  },
  [PROJECT_REPORT_STATUS_APPROVED]: {
    label: "project:approved",
    value: PROJECT_REPORT_STATUS_APPROVED,
    iconType: "inProgressThumbsUpIcon",
    iconTypeV2: "InProgressThumbsupOutlined",
    iconVariant: "success",
  },
  [PROJECT_REPORT_STATUS_SUBMITTED]: {
    label: "project:completed",
    value: PROJECT_REPORT_STATUS_SUBMITTED,
    iconType: "badgeFilledIcon",
    iconTypeV2: "BadgeTickFilled",
    iconVariant: "success",
  },
  [PROJECT_REPORT_STATUS_NON_SUBMISSION]: {
    label: "project:non_submission",
    value: PROJECT_REPORT_STATUS_NON_SUBMISSION,
    iconType: "closeCircleFilledIcon",
    iconTypeV2: "CloseCircleFilled",
    iconVariant: "critical",
  },
  [PROJECT_STATUS_IN_PROGRESS]: {
    label: "project:pending",
    value: PROJECT_STATUS_IN_PROGRESS,
    iconType: "inProgressThumbsUpIcon",
    iconTypeV2: "InProgressThumbsupOutlined",
    iconVariant: "success",
  },
  [PROJECT_STATUS_REJECTED]: {
    label: "project:rejected",
    value: PROJECT_STATUS_REJECTED,
    iconType: "closeCircleFilledIcon",
    iconTypeV2: "CloseCircleFilled",
    iconVariant: "critical",
  },
};

export const PORTFOLIO_STATUS = [
  {
    label: "project:in_progress",
    value: false,
    icon: (
      <InProgressThumbsupOutlined
        style={{ color: "var(--teal-600)" }}
        overrideVariantStyles={true}
        variant="success"
      />
    ),
  },
  {
    label: "common:completed",
    value: true,
    icon: (
      <BadgeTickFilled
        style={{ color: "var(--teal-600)" }}
        overrideVariantStyles={true}
      />
    ),
  },
];

export const LOCALE_PROJECT_TYPE = {
  [PROJECT_GROUP_TYPE_COMMUNITY]: "project:community_project",
  [PROJECT_GROUP_TYPE_PERSONAL]: "project:personal_project",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:activity",
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:cas",
  [PROJECT_GROUP_TYPE_DP_EE]: "project:extended_essay",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: "project:tok_exhibition",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "project:tok_essay",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "project:service_learning",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: "project:reflective_project",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:community_engagement",
};

export const PORTFOLIO_PROJECT_STATUS_INSIGHTS_OPTIONS = [
  PROJECT_STATUS_COMPLETED,
  PROJECT_STATUS_DRAFT,
  PROJECT_STATUS_APPROVED,
];

export const getIsCurriculumACSEnabled = () => {
  return ACLStore.can("FeatureFlag:enableCurriculumWiseCriteriaSetForMYP");
};
